import { useContext, useMemo } from "react";

import { OrganizationsContext } from "@/contexts/organizations";

import { DevelopmentFeatureFlags, PracticeFeatureFlags } from "../constants/feature-flags";

export default function useFeature(name: PracticeFeatureFlags | DevelopmentFeatureFlags) {
  const { features } = useContext(OrganizationsContext);

  const isEnabled = useMemo(
    () =>
      features.practice.includes(name as PracticeFeatureFlags) ||
      features.development.includes(name as DevelopmentFeatureFlags),
    [features, name],
  );

  return isEnabled;
}
